/**
 * Generated from ch9_p02.fla
 */
export function ch9_p02(this: Ich9_p02) {
	const holly = this.holly;
	if (!holly[0] && holly.elementFactory) {
		holly[0] = holly.elementFactory(0,undefined);
	}
	if (holly[0]) {
		ch9_p02_hh_ch9_72dpi_p023psdAssetchp9_p02_holly.call(holly[0] as Ich9_p02_hh_ch9_72dpi_p023psdAssetchp9_p02_holly);
		holly[0].x = 839;
		holly[0].y = 768;
		holly[0].width = 484.00;
		holly[0].height = 678.00;
		holly[0].alpha = 1;
		if (holly[0].onLayout) holly[0].onLayout();
	}
	if (!holly[1] && holly.elementFactory) {
		holly[1] = holly.elementFactory(1,undefined);
	}
	if (holly[1]) {
		ch9_p02_hh_ch9_72dpi_p023psdAssetchp9_p03_holly.call(holly[1] as Ich9_p02_hh_ch9_72dpi_p023psdAssetchp9_p03_holly);
		holly[1].x = 839;
		holly[1].y = 768;
		holly[1].width = 484.00;
		holly[1].height = 681.00;
		holly[1].alpha = 1;
		if (holly[1].onLayout) holly[1].onLayout();
	}
	const bg = this.bg;
	ch9_p02_hh_ch9_72dpi_p023psdAssetchp9_p02_bg.call(this.bg);
	bg.x = 832;
	bg.y = 384;
	bg.width = 1664.00;
	bg.height = 768.00;
	bg.alpha = 1.00;
	if (bg.onLayout) bg.onLayout();
	const frameRight = this.frameRight;
	ch9_p02_hh_ch9_72dpi_p023psdAssetchp9_p02_wcframeRframe.call(this.frameRight);
	frameRight.x = 1664;
	frameRight.y = 384;
	frameRight.width = 351.00;
	frameRight.height = 768.00;
	frameRight.alpha = 1.00;
	if (frameRight.onLayout) frameRight.onLayout();
	const frameLeft = this.frameLeft;
	ch9_p02_hh_ch9_72dpi_p023psdAssetchp9_p02_wcframeLframe.call(this.frameLeft);
	frameLeft.x = 0;
	frameLeft.y = 384;
	frameLeft.width = 345.50;
	frameLeft.height = 768.00;
	frameLeft.alpha = 1.00;
	if (frameLeft.onLayout) frameLeft.onLayout();
	return this;
}
function ch9_p02_hh_ch9_72dpi_p023psdAssetchp9_p02_bg(this: Ich9_p02_hh_ch9_72dpi_p023psdAssetchp9_p02_bg) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp9_p02_bg", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch9_p02_hh_ch9_72dpi_p023psdAssetchp9_p02_holly(this: Ich9_p02_hh_ch9_72dpi_p023psdAssetchp9_p02_holly) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp9_p02_holly", 0.500, 1.000);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch9_p02_hh_ch9_72dpi_p023psdAssetchp9_p03_holly(this: Ich9_p02_hh_ch9_72dpi_p023psdAssetchp9_p03_holly) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp9_p03_holly", 0.500, 1.000);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch9_p02_hh_ch9_72dpi_p023psdAssetchp9_p02_wcframeRframe(this: Ich9_p02_hh_ch9_72dpi_p023psdAssetchp9_p02_wcframeRframe) {
	if (this.setLayoutTexture) this.setLayoutTexture("Rframe", 1.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("screen");
	return this;
}
function ch9_p02_hh_ch9_72dpi_p023psdAssetchp9_p02_wcframeLframe(this: Ich9_p02_hh_ch9_72dpi_p023psdAssetchp9_p02_wcframeLframe) {
	if (this.setLayoutTexture) this.setLayoutTexture("Lframe", 0.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("screen");
	return this;
}
interface Ich9_p02Array<T> {
	[index: number]: T;
	elementFactory?(index:number, parameters?:any): T;
}
interface Ich9_p02Container {
	x?: number;
	y?: number;
	scale?: {x:number, y:number};
	rotation?: number;
	width?: number;
	height?: number;
	onLayout?(): void;
}
interface Ich9_p02Sprite extends Ich9_p02Container {
	setLayoutTexture?(name: string, anchorX :number, anchorY :number): void;
	alpha: number;
	setBlendMode?(blendMode: string): void;
}
interface Ich9_p02Text extends Ich9_p02Container {
	fontSize: number;
	textAreaWidth: number;
	textAreaHeight: number;
}
interface Ich9_p02Polygon extends Array<number> {
}
interface Ich9_p02 {
	readonly holly: Ich9_p02Array<Ich9_p02_hh_ch9_72dpi_p023psdAssetchp9_p02_holly|Ich9_p02_hh_ch9_72dpi_p023psdAssetchp9_p03_holly>;
	readonly bg: Ich9_p02_hh_ch9_72dpi_p023psdAssetchp9_p02_bg;
	readonly frameRight: Ich9_p02_hh_ch9_72dpi_p023psdAssetchp9_p02_wcframeRframe;
	readonly frameLeft: Ich9_p02_hh_ch9_72dpi_p023psdAssetchp9_p02_wcframeLframe;
}
interface Ich9_p02_hh_ch9_72dpi_p023psdAssetchp9_p02_bg extends Ich9_p02Sprite {
}
interface Ich9_p02_hh_ch9_72dpi_p023psdAssetchp9_p02_holly extends Ich9_p02Sprite {
}
interface Ich9_p02_hh_ch9_72dpi_p023psdAssetchp9_p03_holly extends Ich9_p02Sprite {
}
interface Ich9_p02_hh_ch9_72dpi_p023psdAssetchp9_p02_wcframeRframe extends Ich9_p02Sprite {
}
interface Ich9_p02_hh_ch9_72dpi_p023psdAssetchp9_p02_wcframeLframe extends Ich9_p02Sprite {
}
